import * as Sentry from "@sentry/react";
import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

function isDebugSentryAllowed(): boolean {
  return import.meta.env.VITE_SENTRY_ENVIRONMENT === "local";
}

/** Sends a test error to Sentry. Only when `VITE_SENTRY_ENVIRONMENT=local`. */
export default function DebugSentryPage() {
  const [status, setStatus] = useState<"sending" | "done" | "no-dsn">("sending");

  useEffect(() => {
    if (!isDebugSentryAllowed()) {
      return;
    }
    const dsn = import.meta.env.VITE_SENTRY_DSN;
    if (!dsn) {
      setStatus("no-dsn");
      return;
    }
    Sentry.captureException(new Error("tma-fe Sentry test (GET /debug-sentry)"));
    void Sentry.flush(2000).then(() => {
      setStatus("done");
    });
  }, []);

  if (!isDebugSentryAllowed()) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="flex min-h-[40vh] flex-col items-center justify-center gap-3 p-8">
      <h1 className="text-xl font-semibold text-neutral-900">Sentry test</h1>
      {status === "no-dsn" && (
        <p className="text-sm text-amber-700">Set VITE_SENTRY_DSN in .env, then reload.</p>
      )}
      {status === "sending" && <p className="text-sm text-neutral-600">Sending…</p>}
      {status === "done" && (
        <p className="text-sm text-neutral-600">Sent. Check Sentry Issues for this environment.</p>
      )}
    </div>
  );
}
